module.exports = __webpack_public_path__ + "static/media/hero-img.205f358b.png";